// extracted by mini-css-extract-plugin
export default {"addSimCardModal":"AddSimCardModal_addSimCardModal__PSMHu","formGroup":"AddSimCardModal_formGroup__O0YXL"};